var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/ui/components/bundle.tsx";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
const emptyComponent = () => null;
const noop = () => {};
class Bundle extends React.PureComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "unmounted", false);
    _defineProperty(this, "timeout", void 0);
    _defineProperty(this, "timestamp", void 0);
    _defineProperty(this, "state", {
      mod: undefined,
      forceRender: false
    });
    _defineProperty(this, "load", props => {
      const {
        fetchComponent,
        onFetch,
        onFetchSuccess,
        onFetchFail,
        renderDelay
      } = props || this.props;
      const cachedMod = Bundle.cache.get(fetchComponent);
      if (this.unmounted) return Promise.resolve();
      if (fetchComponent === undefined) {
        this.setState({
          mod: null
        });
        return Promise.resolve();
      }
      onFetch();
      if (cachedMod) {
        this.setState({
          mod: cachedMod.default
        });
        onFetchSuccess();
        return Promise.resolve();
      }
      this.setState({
        mod: undefined
      });
      if (renderDelay !== 0) {
        this.timestamp = new Date();
        this.timeout = setTimeout(() => this.setState({
          forceRender: true
        }), renderDelay);
      }
      return fetchComponent().then(mod => {
        Bundle.cache.set(fetchComponent, mod);
        if (this.unmounted) return;
        this.setState({
          mod: mod.default
        });
        onFetchSuccess();
      }).catch(error => {
        if (this.unmounted) return;
        this.setState({
          mod: null
        });
        onFetchFail(error);
      });
    });
  }
  componentDidMount() {
    this.load(this.props);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.fetchComponent !== this.props.fetchComponent) {
      this.load(nextProps);
    }
  }
  componentWillUnmount() {
    this.unmounted = true;
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }
  render() {
    const {
      loading: Loading,
      error: Error,
      children,
      renderDelay
    } = this.props;
    const {
      mod,
      forceRender
    } = this.state;
    const elapsed = this.timestamp ? new Date().getTime() - this.timestamp.getTime() : renderDelay;
    if (mod === undefined) {
      return elapsed >= renderDelay || forceRender ? /*#__PURE__*/React.createElement(Loading, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 91,
          columnNumber: 56
        }
      }) : null;
    }
    if (mod === null) {
      return /*#__PURE__*/React.createElement(Error, {
        onRetry: this.load,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 95,
          columnNumber: 14
        }
      });
    }
    return children(mod);
  }
}
_defineProperty(Bundle, "defaultProps", {
  loading: emptyComponent,
  error: emptyComponent,
  renderDelay: 0,
  onFetch: noop,
  onFetchSuccess: noop,
  onFetchFail: noop
});
_defineProperty(Bundle, "cache", new Map());
export default Bundle;